// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;He set their feet on the right way&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;till they came to a city to dwell in.<br> </p> </div></div>";
// Exports
module.exports = code;